<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<div class="co-content-header" v-if="step < $const.STEP_RECEIPT">
			<h1 v-bind="ADAattr('h1')" aria-level="1">Checkout</h1>
			<div
				v-if="has_products && refresh_shopping_cart_timer === null && hold_left > 0"
				class="co-content-header-right" tabindex="0" role="heading" aria-level="2"
				v-bind="[
					ADAattr('label', ada_hold_timer)
				]"
			>
				<span v-bind="ADAattr('hidden')">
					Holding your items for: <v-icon size="22px">schedule</v-icon> {{ hold_timer }}
				</span>
			</div>
		</div>

		<v-container grid-list-md v-if="loading" pa-0>
			<v-progress-linear :indeterminate="true" v-bind="ADAattr('progress', 'Loading checkout')"></v-progress-linear>
		</v-container>

		<template v-else>
			<v-container grid-list-md v-if="has_products" pa-0 id="co-content-body">
				<v-layout row wrap>
					<v-flex class="co-main-container">
						<v-layout row wrap class="steps-wrapper">
							<v-flex mb2 d-flex xs12 :id="`checkout-step-${$const.STEP_LOGIN}`" class="co-section" v-if="step === $const.STEP_LOGIN">
								<login
										:step="step"
										:asi-form="$globs['asi_login_form']"

										@change-step="changeStep"
										@submit="onSubmitEmail"
                    @login="onLogin"
								></login>
							</v-flex>
							<v-flex mb2 pb-4 d-flex xs12 :id="`checkout-step-${$const.STEP_SHIPPING_ADDRESS}`" class="co-section"
									v-if="step < $const.STEP_RECEIPT">
								<v-card flat>
									<shipping-address
											:contacts="contacts"
											:guest="guest"
											:step="step"
											:preselected_idx="!contacts.addresses.length ? -1 : preselected_idx"
											:disable_apo_states="$globs['has_rental']"
											:saving_address="saving_address"
											:submitting_address="submitting_address && !submitting_exemption_form"
											:disable-editing="placing_order"
											:show_extra_info="this.orderSummaryExperimentVariant() === 'sticky' && step < $const.STEP_PAYMENT"
											:extra_info="extra_info"

											@change-step="changeStep"
											@submit="onSubmitAddress"
											@save="onSaveAddress"
											@editing-address="onEditingAddress"
											@selected-address-changed="onSelectedAddressChanged"
											@subscribe-changed="onSubscribeChanged"
									></shipping-address>
								</v-card>
							</v-flex>
							<v-flex mb2 pb-4 d-flex xs12 :id="`checkout-step-${$const.STEP_TAX_EXEMPT}`" class="co-section"
									v-if="step === $const.STEP_TAX_EXEMPT">
								<v-card flat>
									<tax-exempt-form
											:schools="$globs['tax_exempt_settings']['schools']"
											:submitting="submitting_exemption_form"

											@submit="onSubmitTaxExempt"
											@skip="onSkipTaxExempt"
									></tax-exempt-form>
								</v-card>
							</v-flex>
							<v-flex mb2 pb-4 d-flex xs12 :id="`checkout-step-${$const.STEP_SHIPPING_METHOD}`" class="co-section"
									v-if="step < $const.STEP_RECEIPT">
								<v-card flat>
									<shipping-method
											:sections="products"
											:step="step"
											:disable-editing="placing_order"
											:submitting="submitting_shipping_method"
											:is_usa="is_usa"
											:flexpay-store="$globs['flex_pay_store']"

											@change-step="changeStep"
											@submit="onSubmitShipping"
									></shipping-method>
								</v-card>
							</v-flex>
							<template v-if="step < $const.STEP_RECEIPT">
								<payment-methods
										ref="payment_methods"
										:id="`checkout-step-${$const.STEP_PAYMENT}`"

										:payments="payment_methods"
										:items="products"
										:order-data="order_data"
										:tax-exempt="tax_exempt"
										:step="step"
										:summary="summary"
										:flexpay-store="$globs['flex_pay_store']"
										:is_logged_in="is_logged_in"
										:placing_order="placing_order"
										:enable-same-address-as-shipping="!selected_address || selected_address['source'] !== 'campus_dropdown'"
										:customer-token="getTokenReq()"

										@change-step="changeStep"
										@submit="onSubmitPayment"
										@applied-coupon="onAppliedCoupon"
										@applied-discount="onAppliedDiscount"
										@updated-payment-method="onUpdatedPaymentMethod"
										@selected-restricted-method="onSelectedRestrictedMethod"
										@updated-financial-aid="onUpdatedFinancialAid"
										@selected-online-method="onSelectedOnlineMethod"
										@canceled-online-method="onCanceledOnlineMethod"
								></payment-methods>
							</template>
						</v-layout>
					</v-flex>
					<v-flex d-block class="co-sticky-container" id="co-sidebar">
						<v-layout class="co-sticky" row wrap :class="{'sticky': this.isStickyEnabled()}"
								  :style="{'max-width': sidebar_width ? sidebar_width + 'px' : 'auto'}">
							<v-flex xs12 v-if="this.isOrderSummaryVisible()">
								<v-card flat>
									<order-summary
											:charges="summary.charges"
											:payments="summary.payments"
											:total="summary.total"
											:online-payment="online_payment"
											:is-incomplete="this.orderSummaryExperimentVariant() === 'sticky' && step < $const.STEP_PAYMENT"
											v-if="step < $const.STEP_RECEIPT"
											v-bind="ADAattr('hidden')"
									></order-summary>
								</v-card>
							</v-flex>

							<v-flex xs12 v-if="step < $const.STEP_RECEIPT && (this.orderSummaryExperimentVariant() !== 'sticky' || step >= $const.STEP_PAYMENT)">
								<v-card flat>
									<extra-checkout-info
											:data="extra_info"
											v-if="extra_info['shown']"
									></extra-checkout-info>
								</v-card>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-container>

			<v-container grid-list-md v-if="has_products" pa-0 :id="`checkout-step-${$const.STEP_RECEIPT}`">
				<v-layout row wrap>
					<v-flex class="co-main-container">
						<v-layout row wrap class="steps-wrapper">

							<v-flex mb2 d-flex xs12 v-if="step === $const.STEP_RECEIPT">
								<v-card flat>
									<receipt
											:step="step"
											:orders="receipt.orders"
											:payments="receipt.payments"
											:advertisement="receipt.advertisement"
											:cj="receipt.cj"
											:items="products"
											:inactivity-interval="receipt.inactivity_interval"
									></receipt>
								</v-card>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-container>


			<v-container grid-list-md v-else>
				<v-layout row wrap>
					<v-flex xs12>
						<v-flex pa-2 class="co-continue-shopping-block">
							<a href="/" v-bind="ADAattr('label', 'Continue shopping from homepage')">&larr; Continue shopping</a>
						</v-flex>
						<v-card>
							<v-card-title class="sc-empty-msg" v-bind="ADAattr('focus')">
								Your shopping cart is empty
							</v-card-title>
						</v-card>
					</v-flex>
				</v-layout>
			</v-container>
		</template>

		<v-layout row justify-center>
			<v-dialog
				v-model="disabled_international_shipping_dialog"
				@keydown.esc="ADAfocus('#checkout-step-1')"
				@input="ADAfocus('#checkout-step-1')"
				max-width="500"
			>
				<v-card v-bind="ADAattr('dialog', !disabled_international_shipping_dialog, 'ada-disd')">
					<v-card-title class="title pt-4 px-4 pb-0 co-disabled-international-header" v-bind="ADAattr('h2')" id="ada-disd">
						<v-icon color="#DD2C01">error_outline</v-icon>&nbsp;Adjust your shopping cart
					</v-card-title>
					<v-card-text class="pa-4" v-html="disabled_international_shipping_text"></v-card-text>
					<v-card-actions class="px-4 pb-2 pt-0 co-disabled-international-buttons-block">
						<v-spacer></v-spacer>
						<v-btn color="#2170f2" flat href="/sc" v-bind="ADAattr('link')">Go to Shopping Cart</v-btn>
						<v-btn color="#2170f2" flat @click="disabled_international_shipping_dialog = false; ADAfocus('#checkout-step-1')">Choose a different address</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-layout>

		<v-layout row justify-center>
			<v-dialog
				v-model="rental_apo_dialog"
				@keydown.esc="ADAfocus('#checkout-step-1')"
				@input="ADAfocus('#checkout-step-1')"
				max-width="500"
			>
				<v-card v-bind="ADAattr('dialog', !rental_apo_dialog, 'ada-rad')">
					<v-card-title class="title pt-4 px-4 pb-0 co-disabled-international-header" v-bind="ADAattr('h2')" id="ada-rad">
						<v-icon color="#DD2C01">error_outline</v-icon>&nbsp;Adjust your shopping cart
					</v-card-title>
					<v-card-text class="pa-4" v-html="rental_apo_text"></v-card-text>
					<v-card-actions class="px-4 pb-2 pt-0 co-disabled-international-buttons-block">
						<v-spacer></v-spacer>
						<v-btn color="#2170f2" flat href="/sc" v-bind="ADAattr('link')">Go to Shopping Cart</v-btn>
						<v-btn color="#2170f2" flat @click="rental_apo_dialog = false; ADAfocus('#checkout-step-1')">Choose a different address</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-layout>

		<v-layout row justify-center>
			<v-dialog v-model="replacements_dialog" persistent max-width="700px">
				<v-card v-bind="ADAattr('dialog', !replacements_dialog, 'ada-rpsd')">
					<v-card-title v-bind="ADAattr('h2')" id="ada-rpsd">
						<span class="headline">
							Items in your cart have changed since you added them.
						</span>
					</v-card-title>
					<v-card-text>
						<div class="mb-4" v-bind="ADAattr('focus')">
							<v-icon>info</v-icon>
							The items below were removed from your cart because price or availability has changed.
							You can select replacements or go without these items.
						</div>

						<template v-for="item in replacements">
							<alternative-item-selector
									:item="item"
									@add-to-cart="item.addToCart"
							></alternative-item-selector>

						</template>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="#2170f2" dark @click="replacementsDone(); ADAfocus('#checkout-step-3')" v-bind="ADAattr('label', 'Continue to shipping method')">Done</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-layout>

		<v-snackbar
				v-model="notice.shown"
				bottom
				:timeout="notice.timeout"
				:color="notice.color"
				dark
				multi-line
				auto-height
		>
			<template v-slot:default>
				<span
					v-html="notice.text"
					class="message-box-content"
					v-bind="[
						ADAattr('alert', notice.severity),
						ADAfocus('notice.shown', ADAquerySelector('alert'))
					]"
				></span>
				<v-btn
						flat
						@click="notice.shown = false"
						v-bind="ADAattr('label', 'Return')"
				>
					Close
				</v-btn>
			</template>

		</v-snackbar>
	</div>
</template>

<script>
	import Login from './Login';
	import ShippingMethod from './ShippingMethod';
	import ShippingAddress from './ShippingAddress';
	import PaymentMethods from './PaymentMethods';
	import Receipt from './Receipt';
	import OrderSummary from './OrderSummary';
	import ExtraCheckoutInfo from "./ExtraCheckoutInfo";
	import AlternativeItemSelector from './../../common/components/vuejs/AlternativeItemSelector';
	import Axios from 'axios';
	import _ from 'lodash';
	import TaxExemptForm from "./TaxExemptForm";
	import {EventBus} from "./../includes/EventBus";
	import {isUSA, parseErrorResponse} from "./../includes/Miscellaneous";

	export default {
		name: "CheckoutMain",

		components: {
			TaxExemptForm,
			Login,
			ShippingMethod,
			Receipt,
			ShippingAddress,
			PaymentMethods,
			OrderSummary,
			ExtraCheckoutInfo,
			AlternativeItemSelector,
		},

		mounted() {
			const self = this;

			EventBus.$on('show-message', ({msg, severity = 0, timeout = 6000}) => {
				self.notice.shown = true;
				self.notice.text = msg;
				self.notice.severity = severity;
				self.notice.timeout = timeout;
				self.notice.color = ['success', 'info', 'error'][Math.min(severity, 2)];
			});

			EventBus.$on('ecommerce-event', ({action, data}) => {
				window.fillEcommerceProducts(self.ga_products);
				window.sendEcommerceAction(action, data);
			});

			self.products = [];

			self.getCheckoutData();
			self.updateSummaryIfVisible();

			window.addEventListener('scroll', function (e) {
				const isInViewport = function (elem) {
					if (!elem) return false;
					const bounding = elem.getBoundingClientRect();
					return bounding.top >= 0;
				};

				self.top_in_viewport = isInViewport(document.getElementById('co-content-body'));
				let sidebar = document.getElementById('co-sidebar');
				self.sidebar_width = sidebar ? sidebar.getBoundingClientRect().width : 'auto';
			});

			self.ga_products = self.$globs['ga_products'];

			self.initHoldTimer();

			EventBus.$emit('ecommerce-event', {
				action: 'begin_checkout',
			});

		},

		data() {
			return {
				step: this.$const.STEP_LOGIN,

				products: [],

				loading: true,
				is_logged_in: false,
				has_products: false,
				customer_token: null,
				guest: false,

				contacts: {
					email: '',
					alt_email: '',
					subscribe: false,
					emails: [],
					addresses: [],
					user_field: null,
				},

				preselected_idx: null,
				selected_address: null,

				payment_methods: {},
				discount_code: null,

				summary: {
					charges: [],
					payments: [],
					split_totals: [],
					cc_payment: 0,
					total: 0,
				},

				order_data: {
					address_id: null,
					shipping_methods: [],
					gift_certificates: [],
					credit_card_id: null,
					share_order_info: null,
					device_data: '',
				},

				receipt: {
					orders: [],
					payments: {},
					advertisement: [],
					cj: [],
					inactivity_interval: null,
				},

				notice: {
					shown: false,
					text: '',
					timeout: 6000,
					color: 'error',
				},

				tax_exempt: null,
				restricted_payment: null,

				online_payment: '',

				top_in_viewport: true,
				sidebar_width: null,

				placing_order: false,
				saving_address: false,
				submitting_address: false,
				submitting_exemption_form: false,
				submitting_shipping_method: false,

				disabled_international_shipping_dialog: false,
				rental_apo_dialog: false,
				user_logout_timeout: null,
				user_logged_out_timer: null,
				user_hold_timer: null,
				hold_left: 0,

				replacements_dialog: false,
				replacements_resolve: false,
				replacements: [],
				refresh_shopping_cart_timer: null,
				refresh_shopping_cart_timer_stop: null,
				is_usa: true,

				selected_apo_address: false,

				ga_products: [],
			};
		},

		methods: {
      getCheckoutData(){
        const self = this;
        Axios.get('/sc/rest/index.php/checkout_info' + self.getTokenReq()).then(({data}) => {
          self.is_logged_in = data['is_logged_in'];
          self.guest = false;
          self.contacts = data['contacts'];
          self.step = self.is_logged_in ? self.$const.STEP_SHIPPING_ADDRESS : self.$const.STEP_LOGIN;
          self.has_products = !self.$globs['empty_cart'];
          self.loading = false;
          self.initLogoutTimer();
          self.sendStepEventToGa();
        });
      },
			isUSA,

			getTokenReq(skip_timeout_timer_update = false) {
				const skip = (this.customer_token ? '&' : '?') + 'skip_timeout_timer_update=true';
				return (this.customer_token ? '?customer_token=' + this.customer_token : '')
					+ (skip_timeout_timer_update ? skip : '');
			},

			initHoldTimer() {
				const self = this;
				self.hold_left = parseInt(self.$globs['cart_hold_expiration']);

				self.user_hold_timer = window.setInterval(() => {
					self.hold_left--;
					if (self.hold_left < 0) {
						self.hold_left = 0;
						window.clearInterval(self.user_hold_timer);
					}
				}, 1000);
			},

			initLogoutTimer() {
				const self = this;

				if (!self.is_logged_in) {
					return;
				}

				const logout_link = '/account/logout.php?timeout=1';
				const callback = () => {
					Axios.get('/tools/ajax/check_logout.php').then(({data}) => {

						if (data['user_timed_out'] === true) {
							window.location.href = logout_link;
							return;
						}

						const time_left = parseInt(data['user_timed_out']);
						window.setTimeout(callback, time_left > 60 ? 30000 : 5000);
					});
				};

				window.setTimeout(callback, 5000);

				self.user_logged_out_timer = window.setInterval(() => {
					if (document.cookie && document.cookie.match(/user_logged_out=true/)) {
						if (self.user_logged_out_timer) {
							window.clearInterval(self.user_logged_out_timer);
						}

						window.location.href = logout_link;
						return;
					}
				}, 5000);
			},

			changeStep(step) {
				this.step = step;

				_.each(this.$const, (value, key) => {
					if (value == step) {
						document.body.classList.add(_.kebabCase(key));
					} else {
						document.body.classList.remove(_.kebabCase(key));
					}
				});

				window.setTimeout(() => {
					const target = this.$el.querySelector(`#checkout-step-${step}`);
					if (_.isElement(target)) {
						this.$vuetify.goTo(target);
						const heading = target.querySelector('.section-title h1, .co-order-summary-info h1');
						if (_.isElement(heading)) {
							heading.focus();
						}
					}
				}, this.ADA_DOM_UPDATE_TIMEOUT);

				EventBus.$emit('ecommerce-event', {
					action: 'checkout',
					data: {step},
				});

				this.sendStepEventToGa();

			},

			isAPOState(state) {
				return this.$globs['apo_states'].includes(state);
			},

      isStickyEnabled() {
        if(!this.top_in_viewport) {
          const experiment_variant = this.orderSummaryExperimentVariant();
          if (experiment_variant !== 'original') {
            return this.isOrderSummaryVisible();
          }
        }
        return false;
      },

      orderSummaryExperimentVariant() {
        let experiment_variant = this.$globs['order_summary_sticky_variant'];
        if (!experiment_variant || experiment_variant === 'vwo') {
          experiment_variant = 'original';
        }
        return experiment_variant;
      },

      isOrderSummaryVisible() {
        return this.orderSummaryExperimentVariant() === 'sticky' ? true : this.step >= this.$const.STEP_PAYMENT;
      },

			updateSummary() {
				const self = this;

				let restricted_pay =
					self.restricted_payment && self.restricted_payment['payment']
					&& self.restricted_payment['payment']['method'] && self.restricted_payment['payment']['method']['selected']
						? (self.restricted_payment['payment']['type'] === 'financial_aid' ? 'financial_aid' : self.restricted_payment['payment']['method']['id'])
						: null;

				let eligible_lines = self.restricted_payment ? self.restricted_payment['eligible_lines'] : null;

				let gcs = null;
				if (self.payment_methods.gift_certificates && self.payment_methods.gift_certificates.options) {
					gcs = _.map(_.filter(self.payment_methods.gift_certificates.options, gc => gc.selected), gc => gc.id);
				}
				let address_id = self.order_data.address_id;
				if(!address_id && this.step < this.$const.STEP_PAYMENT && this.orderSummaryExperimentVariant() === 'sticky') {
					address_id = -1;
				}
				Axios.post('/sc/rest/index.php/order_summary' + self.getTokenReq(), {
					address_id: address_id,
					shipping_methods: self.order_data.shipping_methods,
					promotion_code: self.discount_code && self.discount_code.code ? self.discount_code.code : null,
					customer_token: self.customer_token,
					tax_exempt: self.tax_exempt,
					restricted_payment_id: restricted_pay,
					financial_aid_balance: self.payment_methods.financial_aid && self.payment_methods.financial_aid.selected ? self.payment_methods.financial_aid.balance : null,
          financial_aid_tax_exempt: self.payment_methods.financial_aid && self.payment_methods.financial_aid.tax_exempt,
          gift_certificates: gcs,
					eligible_lines
				}).then(({data}) => {

					self.summary = {};

					_.forEach(
						['charges', 'payments'],
						(sec_name) => {
							self.summary[sec_name] = _.map(data[sec_name], (v, k) => {
								return {name: k, value: v};
							});
						},
					);

					this.summary.split_totals = data['split_totals'];

					self.summary.total = data['total'];
					self.summary.cc_payment = data['payments'] && data['payments']['cc_payment'] ? data['payments']['cc_payment'] : 0;
				}).catch((error) => {
					EventBus.$emit('show-message', {
						msg: parseErrorResponse(error.response),
						severity: 2,
					});
				});

			},

			onSubmitEmail(payload) {
				const self = this;

				if (payload.success) {
					self.guest = true;
					self.contacts.email = payload.data.email;
					self.changeStep(self.$const.STEP_SHIPPING_ADDRESS);
				}
			},

      onLogin(payload) {
        const self = this;
        if (payload.success) {
          console.log("LoggedIn", payload);
          self.getCheckoutData();
        }
      },

			onSaveAddress(payload) {
				this.saving_address = true;

				let url;
				if (payload.id > 0) {
					url = '/sc/rest/index.php/edit_address/';
				} else if (this.guest) {
					url = '/sc/rest/index.php/create_account/';
				} else {
					url = '/sc/rest/index.php/add_address/';
				}

				Axios.post(url, {
					...payload,
					email: this.contacts.email,
					customer_token: this.customer_token

				}).then(({data}) => {
					this.customer_token = data.customer_token || this.customer_token;
					this.contacts.addresses = data.addresses || data;
					this.preselected_idx = false;
					this.$nextTick(() => {
						const idx = _.findIndex(this.contacts.addresses, 'is_default');
						this.preselected_idx = idx > -1 ? idx : null;
					});

				}).catch(error => {
					EventBus.$emit('show-message', {
						msg: parseErrorResponse(error.response),
						severity: 2,
					});

				}).finally(() => {
					this.saving_address = false;
				});
			},

			refreshShoppingCartTimer() {
				const self = this;

				Axios.post('/sc/rest/index.php/refresh_shopping_cart_timer' + this.getTokenReq(true)).catch(err => {
					if (self.refresh_shopping_cart_timer !== null) {
						window.clearInterval(self.refresh_shopping_cart_timer);
					}
					if (self.refresh_shopping_cart_timer_stop !== null) {
						window.clearTimeout(self.refresh_shopping_cart_timer_stop);
					}
				});
			},

			async fetchShippingMethods(address_id) {
				const self = this;

				self.submitting_exemption_form = true;
				self.submitting_address = true;

				const has_replacements = await self.getUnavailableLines();

				if (!has_replacements) {
					return;
				}

				Axios.get('/sc/rest/index.php/shipping_methods/' + address_id + self.getTokenReq()).then(({data}) => {
					const prods = _.map(data, (x) => {
						x.books = _.map(x.books, book => self.prepareBook(book));
						x.selected_shipping = _.find(x['shipping_methods']['all_methods'], (v) => v['id'] === x['shipping_methods']['id']);

						return x;
					});

					self.order_data.address_id = address_id;
					self.products = prods;
					self.changeStep(self.$const.STEP_SHIPPING_METHOD);

					self.submitting_exemption_form = false;
					if (self.products.length === 0) {
						self.has_products = false;
					}
				}).finally(() => {
					self.submitting_address = false;
				});

				if (self.refresh_shopping_cart_timer === null) {
					self.refresh_shopping_cart_timer = window.setInterval(() => {
						self.refreshShoppingCartTimer();
					}, 5 * 60 * 1000);

					// stop keeping persistent hold after 1 hour
					self.refresh_shopping_cart_timer_stop = window.setTimeout(() => {
						if (self.refresh_shopping_cart_timer !== null) {
							window.clearInterval(self.refresh_shopping_cart_timer);
						}
					}, 61 * 60 * 1000);

					self.refreshShoppingCartTimer();
				}
			},

			isAllowedState(state) {
				return !this.$globs['has_rental'] || !this.$globs['apo_states'].includes(state);
			},

			async onSubmitAddress(payload) {
				const self = this;

				if (!self.isUSA(payload.data.country) && self.disable_international_shipping) {
					self.disabled_international_shipping_dialog = true;
					return;
				}

				if (self.isUSA(payload.data.country) && !self.isAllowedState(payload.data.state)) {
					self.rental_apo_dialog = true;
					return;
				}

				if (typeof payload['user_field'] !== 'undefined' && payload['user_field'] !== null) {
					self.contacts.user_field = payload['user_field'];
				}

				if (typeof payload['alt_email'] !== 'undefined' && payload['alt_email'] !== null) {
					self.contacts.alt_email = payload['alt_email'];
				}

				const address = _.find(self.contacts.addresses, x => x['id'] === payload.data.address_id);

				self.selected_address = address;
				let submitted_alt_email = await self.updateCustomerInformation();

				if (!submitted_alt_email) {
					return;
				}

				if (!self.$globs['tax_exempt_settings']['institute_tax_exempt'] && self.$globs['tax_exempt_settings']['states'].includes(address['state'])) {
					self.showTaxExemptStep();
				} else {
					self.fetchShippingMethods(payload.data.address_id);
				}
				self.updateSummaryIfVisible();
			},

			onSubmitShipping(payload) {
				const self = this;

				self.submitting_shipping_method = true;

				if (payload.success) {
					self.order_data.shipping_methods = payload.data.shipping_methods;

					self.updateSummary();

					Axios.get('/sc/rest/index.php/get_payments/' + self.getTokenReq()).then(({data}) => {
						const payments = data.payment_methods;

						if ('financial_aid' in payments) {
							payments.financial_aid.selected = this.$globs['checkout_preferences']['payment'] === 'fa';
							payments.financial_aid.enabled = true;
						}

						if ('gift_certificates' in payments) {
							payments.gift_certificates.options = _.map(payments.gift_certificates.options, x => self.attachDefaultGCProperties(x));
						}

						if ('credit_cards' in payments) {
							payments.credit_cards.enabled = true;
							payments.credit_cards.use_cc = true;
							payments.credit_cards.selected_cc = null;
							payments.credit_cards.cc_type = 'cc';
						}

						self.payment_methods = payments;

						self.changeStep(self.$const.STEP_PAYMENT);
						self.submitting_shipping_method = false;
					});
				}
			},

			onSubmitPayment(payload) {
				const self = this;

				if (payload.success) {
					self.order_data.payments = payload.data;

					let restricted_payment_id = null;
					if (self.restricted_payment && self.restricted_payment.payment) {
						restricted_payment_id = self.restricted_payment.payment.type === 'financial_aid' ?
							'financial_aid'
							: self.restricted_payment.payment.method.id;
					}

					self.placing_order = true;

					Axios.post('/sc/rest/index.php/place_order/',
						{
							address_id: self.order_data.address_id,
							shipping_methods: self.order_data.shipping_methods,
							apply_financial_aid: self.order_data.payments.financial_aid,
							gift_certificates: self.order_data.payments.gift_certificates,
							promotion_code: self.order_data.payments.promotion_code,
							credit_card_id: self.order_data.payments.credit_card_id,
							restricted_payment_id,

							account_number: self.order_data.payments.account_number,
							card_type: self.order_data.payments.card_type,
							cvv: self.order_data.payments.cvv,
							exp_year: self.order_data.payments.exp_year,
							exp_month: self.order_data.payments.exp_month,
							label: self.order_data.payments.label,
							cardholder_name: self.order_data.payments.cardholder_name,

							billing_address: self.order_data.payments.billing_address,
							share_order_info: self.order_data.payments.share_order_info,
							braintree_device_data: self.order_data.payments.device_data,
							customer_token: self.customer_token,
							save_cc: self.order_data.payments.save_cc,
							tax_exempt: self.tax_exempt,
							user_field: self.contacts.user_field,

							flexpay: self.order_data.payments.flexpay || null,

							customer_password: self.order_data.payments.customer_password,
							customer_password_confirm: self.order_data.payments.customer_password_confirm,

							captcha_response: self.order_data.payments.captcha_response,
						},
					).then(({data}) => {
						self.changeStep(self.$const.STEP_RECEIPT);

						if (data.orders && _.isArray(data.orders)) {
							_.forEach(data.orders, order => {
								if (window.vwoTrackRevenueConversion) {
									window.vwoTrackRevenueConversion(order.ga_data.order_total);
								}

								EventBus.$emit('ecommerce-event', {
									action: 'purchase',
									data: {
										'transaction_id': order.ga_data.order_id,           // order ID - required
										'affiliation': order.ga_data.affiliate, // affiliation or store name
										'value': order.ga_data.order_total,          // total - required
										'tax': order.ga_data.tax,           // tax
										'shipping': order.ga_data.shipping,          // shipping
									},
								});
							});
						}

						self.receipt.orders = data.orders;
						self.receipt.advertisement = data.advertisement;
						self.receipt.cj = data.cj;
						self.receipt.inactivity_interval = data.receipt_inactivity_interval;

						if (self.refresh_shopping_cart_timer !== null) {
							window.clearInterval(self.refresh_shopping_cart_timer);
							self.refresh_shopping_cart_timer = null;
						}
					}).catch(error => {
						self.$refs.payment_methods.resetCaptchas();

						EventBus.$emit('show-message', {
							msg: parseErrorResponse(error.response),
							severity: 2,
							timeout: 15000,
						});
					}).finally(x => {
						self.placing_order = false;
					});

				}
			},

			onAppliedCoupon(payload) {
				const self = this;

				if (payload.success) {
					if (!self.payment_methods['gift_certificates']) {
						self.payment_methods['gift_certificates'] = [];
					}

					if (!self.payment_methods['gift_certificates']['options']) {
						self.payment_methods['gift_certificates']['options'] = [];
					}

					const gc = self.attachDefaultGCProperties(payload.data['certificate'],
						!self.restricted_payment || !payload.data['certificate']['has_restrictions'],
					); // don't enable by default if has restrictions but some other restricted payment is already selected

					self.payment_methods['gift_certificates']['options'].push(gc);

					EventBus.$emit('show-message', {
						msg: "The code has been added",
						severity: 0,
					});

				} else {
					EventBus.$emit('show-message', {
						msg: payload.error,
						severity: 2,
					});
				}
			},

			onAppliedDiscount(payload) {
				const self = this;

				if (payload.success) {
					self.discount_code = payload.data;

					EventBus.$emit('show-message', {
						msg: "The discount has been applied",
						severity: 0,
					});

					self.updateSummary();
				} else {
					self.discount_code = null;

					EventBus.$emit('show-message', {
						msg: payload.error,
						severity: 2,
					});

					self.updateSummary();
				}
			},

			showTaxExemptStep() {
				const self = this;
				self.changeStep(self.$const.STEP_TAX_EXEMPT);

				if (typeof sendGAAction === 'function') {
					sendGAAction('Checkout: toggle tax exempt block');
				}
			},

			updateSummaryIfVisible() {
			  if (this.isOrderSummaryVisible()) {
				  this.updateSummary(true);
			  }
			},

			onSubmitTaxExempt(payload) {
				const self = this;

				self.tax_exempt = payload.data;

				self.fetchShippingMethods(self.selected_address['id']);
				this.updateSummaryIfVisible();
			},
			onSkipTaxExempt() {
				const self = this;

				self.fetchShippingMethods(self.selected_address['id']);
				this.updateSummaryIfVisible();
			},
			onEditingAddress(payload) {
				const self = this;

				if (payload.name === 'state') {
					self.selected_apo_address = this.isAPOState(payload.value);
				}

				if (payload.name === 'country') {
					self.is_usa = isUSA(payload.value);
				}
			},

			onSelectedRestrictedMethod(payload) {
				this.restricted_payment = payload;
			},

			onUpdatedPaymentMethod() {
				this.updateSummary();
			},

			onSelectedOnlineMethod(method) {
				this.online_payment = method;
			},

			onCanceledOnlineMethod() {
				this.online_payment = '';
			},

			attachDefaultGCProperties(gc, selected = false) {
				gc.enabled = true;
				gc.selected = selected;

				return gc;
			},

			async updateCustomerInformation() {
				const self = this;

				let success = true;
				await Axios.post('/sc/rest/index.php/update_customer_information' + self.getTokenReq(), {
					alt_email: self.contacts.alt_email,
					send_promotions: self.contacts.subscribe,
					is_mobile: self.selected_address ? self.selected_address.is_mobile : null,
					address_id: self.selected_address && self.selected_address.id > 0 ? self.selected_address.id : null,
				}).then(({data}) => {
				}).catch((error) => {
					EventBus.$emit('show-message', {
						msg: parseErrorResponse(error.response),
						severity: 2,
					});
					success = false;
				});

				return success;
			},

			onSubscribeChanged(payload) {
				this.contacts.subscribe = payload.subscribe;

				if (this.guest && !this.customer_token) return;

				this.updateCustomerInformation();
			},

			async getUnavailableLines() {
				const self = this;

				return new Promise(resolve => {
					self.replacements_resolve = resolve;

					Axios.get(`/sc/rest/index.php/get_unavailable_lines/${self.getTokenReq()}`).then(({data}) => {

						self.replacements = _.map(data, product => {
							product.addToCart = (payload) => {
								const self = this;

								Axios.post('/sc/rest.php/replace', {
									product_id: payload.product_id,
									order_type: payload.order_type,
									quantity: 1,
									course_id: product.course_id || null,
									replaced_cart_line_id: product.cart_line_id,
								}).then(({data}) => {
									if (!data.new_product) return;

									let rep_id = _.findIndex(self.replacements, item => item.cart_line_id === product.cart_line_id);
									if (rep_id < 0) return;
									self.replacements.splice(rep_id, 1);

									EventBus.$emit('show-message', {
										msg: 'Your item has been replaced',
										severity: 0,
									});

									if (self.replacements.length === 0) {
										self.removeExpiredLines();
										return;
									}
								});

							};
							return product;
						});

						if (!_.isEmpty(self.replacements)) {
							self.replacements_dialog = true;
						} else {
							self.removeExpiredLines();
						}
					});
				});
			},

			removeExpiredLines() {
				const self = this;

				if (self.replacements && self.replacements.length > 0) {
					Axios.post('/sc/rest/index.php/remove_expired_lines' + self.getTokenReq()).then(({data}) => {
						if (self.replacements_resolve) {
							self.replacements_resolve(true);
						}
						self.replacements_dialog = false;
					}).catch(error => {
						EventBus.$emit('show-message', {
							msg: parseErrorResponse(error.response),
							severity: 2,
						});

						self.has_products = false;
						self.replacements_dialog = false;
						if (self.replacements_resolve) {
							self.replacements_resolve(false);
						}
					});
				} else {
					if (self.replacements_resolve) {
						self.replacements_resolve(true);
					}
					self.replacements_dialog = false;
				}
			},

			prepareBook(book) {
				book['cover'] = book['image_medium'] || book['image_small'] || book['image_large'] || '/img/no_image.gif';
				return book;
			},

			replacementsDone() {
				this.replacements_dialog = false;
				this.removeExpiredLines();
			},

			onUpdatedFinancialAid(payload) {
				const self = this;

				if (payload === null || payload.balance === 0) {
					self.payment_methods.financial_aid.selected = false;
					self.payment_methods.financial_aid.enabled = false;
					self.updateSummary();

					return;
				}

				self.payment_methods.financial_aid.enabled = true;
				_.forEach(payload, (v, k) => {
					self.payment_methods.financial_aid[k] = v;
				});
			},

			onSelectedAddressChanged(payload) {
				this.is_usa = payload.idx < 0 || isUSA(payload.country);
				this.selected_apo_address = payload.idx >= 0 && this.isAPOState(payload.state);
			},
			sendStepEventToGa() {
				const event_name = this.stepGAEventNames[this.step];
				if (!event_name) return;
				EventBus.$emit('ecommerce-event', {
					action: event_name
				});
			}
		},

		computed: {
			hold_timer() {
				let date = new Date(null);
				date.setSeconds(this.hold_left);
				return date.toISOString().substr(14, 5);
			},

			items_list() {
				const self = this;
				const prods = [];

				_.forEach(self.products, (section) => {
					_.forEach(section.books, (book) => {
						prods.push(book);
					});
				});

				return prods;
			},

			disable_international_shipping() {
				return !!this.$globs['disable_international_shipping'];
			},


			disabled_international_shipping_text() {
				return `Your shopping cart contains at least one item which cannot currently be shipped outside of the United States.<br/>
					Please view your Shopping Cart and either remove or replace those items indicated as being valid for US addresses only`;
			},

			rental_apo_text() {
				return `Rental items cannot currently be shipped to APO addresses.`;
			},

			extra_info() {
				const self = this;

				// The following block is required to explicitly declare dependencies for this computed
				// All dependencies of computed must be requested without conditions
				// Otherwise, vue.js won't be watching them.
				self.selected_apo_address
				&& self.is_usa
				&& self.disabled_international_shipping_text
				&& self.rental_apo_text;

				let title = "";
				let shipping_tips = [];
				let show_po_box_notice = false;
				let show_apo_warning = false;
				let show_apo_delivery_warning = false;
				let disable_international_shipping = false;
				let disabled_international_shipping_text = false;
				let rental_apo_text = false;
				let require_cc_to_secure_rental = false;
				let enabled_flexpay = false;
				let show_weekend_delivery_notice = false;
				let shown = true;
				let school_domain = "";

				switch (self.step) {
					case self.$const.STEP_LOGIN:
						title = "Login tips";
						shown = false;
						break;

					case self.$const.STEP_SHIPPING_ADDRESS:
					case self.$const.STEP_TAX_EXEMPT:
						title = "Shipping Tips";
						show_po_box_notice = true;
						show_apo_warning = self.$globs['has_rental'] && self.selected_apo_address;
						school_domain = self.$globs['is_inst'] ? self.$globs['true_domain']  : 'www';
						show_apo_delivery_warning = self.selected_apo_address;
						shipping_tips = self.$globs['shipping_tips'];
						disable_international_shipping = !self.is_usa && self.$globs['is_international'] && self.$globs['disable_international_shipping'];
						disabled_international_shipping_text = self.disabled_international_shipping_text;
						rental_apo_text = self.rental_apo_text;
						shown = (self.step === self.$const.STEP_TAX_EXEMPT && this.orderSummaryExperimentVariant() === 'sticky') ? false : true;
						break;

					case self.$const.STEP_SHIPPING_METHOD:
						show_weekend_delivery_notice = self.$globs['show_weekend_delivery_notice'];
						shown = !!show_weekend_delivery_notice;

						break;

					case self.$const.STEP_PAYMENT:
						title = "Payment Tips";
						require_cc_to_secure_rental = self.$globs['has_rental'];
						enabled_flexpay = !!self.$globs['flex_pay_store'];
						shown = require_cc_to_secure_rental || enabled_flexpay;

						break;

					default:
						break;
				}

				return {
					title,
					show_po_box_notice,
					show_apo_warning,
					shipping_tips,
					show_apo_delivery_warning,
					disable_international_shipping,
					disabled_international_shipping_text,
					rental_apo_text,
					require_cc_to_secure_rental,
					enabled_flexpay,
					show_weekend_delivery_notice,
					shown,
					school_domain,
				};
			},


		},

		watch: {
			top_in_viewport() {

			},
		},
	};
</script>

<style scoped lang="less">
	@text_highlight_color: #2170f2;

	.co-sticky-container {
		@media screen and (min-width: 600px) {
			flex: 3;
		}
	}

	.co-main-container {
		@media screen and (min-width: 600px) {
			flex: 7;
		}
	}

	@media screen and (min-width: 600px) {
		.co-sticky {
			&.sticky {
				position: fixed;
				top: 0;
				width: 100%;
			}
		}
	}

	/deep/ .message-box-content {
		a {
			color: #b5e5ea !important;
		}
	}

	@media screen and (max-width: 600px) {
		.steps-wrapper > div {
			margin: 5px 5px 5px 9px;
		}
	}

	.co-disabled-international-header {
		color: #DD2C01;
	}

	/deep/ .sc-empty-msg {
		font-size: 1.5em;
		justify-content: center;
		font-weight: 600;
		color: @text_highlight_color;
	}

	.co-disabled-international-buttons-block {
		@media screen and (max-width: 600px) {
			flex-flow: column;
		}
	}

	.co-continue-shopping-block {
		padding: 8px 0;
		width: 100%;

		& > a {
			font-size: 16px;
			color: #999 !important;
			font-weight: 500;
		}
	}
</style>
